<app-spinner-service></app-spinner-service>
<form [formGroup]="receitaBrutaForm" class="w-auto pt-2 pl-6 pr-6 pb-6" (ngSubmit)="onSubmit()">
   
    <div class="grid p-fluid col-12">

        <div class="col-3">
            <label for="pa">Período</label>
            <input pInputText class="w-full mt-1" inputId="pa" [value]="formatCompetencia(receitaBrutaForm.get('pa')?.value)" readonly variant="filled"/>

        </div>

        <div class="col-3">
            <label for="valorInterno">Receita Mercado Interno</label>
            <p-inputNumber class="w-full mt-1" inputId="valorInterno" formControlName="valorInterno" mode="currency" currency="BRL"
                locale="pt-BR" />
                <small *ngIf="receitaBrutaForm.get('valorInterno')?.invalid && receitaBrutaForm.get('valorInterno')?.touched" class="p-error">
                    Valor Interno é obrigatório.
                </small>
        </div>
        <div class="col-3">
            <label for="valorExterno">Receita Mercado Externo</label>
            <p-inputNumber class="w-full mt-1" inputId="valorExterno" formControlName="valorExterno" mode="currency" currency="BRL"
                locale="pt-BR" />
            <small *ngIf="receitaBrutaForm.get('valorExterno')?.invalid && receitaBrutaForm.get('valorExterno')?.touched" class="p-error">
                Valor Externo é obrigatório.
            </small>
        </div>
        
        <div class="col-12 flex justify-content-between">
            <div class="col-6 p-0 max-w-10rem">
                <p-button type="button" label="Cancelar" icon="pi pi-times" severity="danger" (click)="onCancel()"></p-button>
            </div>
            <div class="col-6 p-0 max-w-10rem">
                <p-button type="submit" label="Salvar" icon="pi pi-check" [disabled]="receitaBrutaForm.invalid"></p-button>
            </div>
        </div>
    </div>
</form>
